import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class OrderService {
    constructor(private http: HttpClient) { }

    getAll(params) {
        return this.http.get<any>(`${environment.apiUrl}/orders`, { params });
    }

    getOrder(/* id */) {
        return this.http.get<any>(`${environment.apiUrl}/orders/order`);
    }

    getGuestOrder(params) {
        return this.http.get<any>(`${environment.apiUrl}/orders/guest-order`,{ params});
    }

    getOrderById(id) {
        return this.http.get<any>(`${environment.apiUrl}/orders/${id}`);
    }

    printOrder(id){
        return this.http.get<any>(`${environment.apiUrl}/orders/${id}/invoice`);
    }

    printOrderUrl(id){
        return `${environment.apiUrl}/orders/${id}/invoice`;
    }

    addPaymentProof(id,params){
        return this.http.post<any>(`${environment.apiUrl}/orders/${id}/payment-proof`,params);
    }

    cancelOrder(params, type?) {
        return this.http.post<any>(`${environment.apiUrl}/${type || 'orders'}/cancel-order`,params);
    }

    getCancelReasonsList() {
        return this.http.get<any>(`${environment.apiUrl}/orders/cancel-reasons`);
    }

    returnOrder(params) {
        return this.http.post<any>(`${environment.apiUrl}/orders/return-order`,params);
    }

    getReturnReasonsList() {
        return this.http.get<any>(`${environment.apiUrl}/orders/return-reasons`);
    }

    payWorkOrder(id) {
        return this.http.get<any>(`${environment.apiUrl}/work-orders/${id}/pay`);
    }

    checkoutWorkOrder(params): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/work-orders/checkout`,  params );
    }

    addCommunication(id, formData) {
        return this.http.post<any>(`${environment.apiUrl}/orders/add-communication/${id}`, formData);
    }

    readCommunications(id) {
        return this.http.post<any>(`${environment.apiUrl}/orders/read-communications/${id}`, {});
    }
}
